import React from "react";

import { Box } from "@catchoftheday/cg-components";
import { styled } from "@catchoftheday/theme";

import { HEADER_XMAS_HAT, HEADER_XMAS_POMPOM } from "../../../consts";

const hatDimensions = ["2.5rem", "2.5rem", "2.5rem", "3rem"];

const ChristmasContainer = styled(Box)`
  position: absolute;
`;

const SantaHat = styled(Box)`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-image: url("${HEADER_XMAS_HAT}");
  background-size: 100%;
  background-repeat: no-repeat;
`;

const SantaPomPom = styled(Box)`
  position: absolute;
  height: 3.5rem;
  background-image: url("${HEADER_XMAS_POMPOM}");
  background-size: 100%;
  background-repeat: no-repeat;
  z-index: 1;
  top: 0px;
  transform-origin: top right;
  animation: waveHat 1.5s ease-in-out infinite;
  @keyframes waveHat {
    0%,
    100% {
      transform: rotate(10deg);
    }
    50% {
      transform: rotate(0);
    }
  }
`;

export const ChristmasTheme: React.FC = () => (
  <ChristmasContainer
    top={["-1.3rem", "-1.0rem", "-1.0rem", "-1.6rem"]}
    width={hatDimensions}
    height={hatDimensions}
    role="img"
    aria-label="Santa hat"
  >
    <SantaHat />
    <SantaPomPom
      width={["1rem", "1rem", "1rem", "1.2rem"]}
      left={["-0.3rem", "-0.3rem", "-0.4rem", "-0.4rem"]}
    />
  </ChristmasContainer>
);
